export { default } from './AccountMessages';



// WEBPACK FOOTER //
// ./app/components/borrowing/accountmessages/AccountMessages/index.js